const allUnits: { addr: any; unit: any }[] = [
  {
    addr: "substation",
    unit: "substation",
  },
  {
    addr: "community",
    unit: "community",
  },
  {
    addr: "lobby",
    unit: "lobby",
  },
  {
    addr: "commercial",
    unit: "commercial",
  },
  {
    addr: "cycle",
    unit: "cycle",
  },
  {
    addr: "entrances",
    unit: "entrances",
  },
  {
    addr: "1",
    unit: "101",
  },
  {
    addr: "2",
    unit: "102",
  },
  {
    addr: "3",
    unit: "103",
  },
  {
    addr: "4",
    unit: "104",
  },
  {
    addr: "5",
    unit: "105",
  },
  {
    addr: "6",
    unit: "106",
  },
  {
    addr: "7",
    unit: "107",
  },
  {
    addr: "8",
    unit: "201",
  },
  {
    addr: "9",
    unit: "202",
  },
  {
    addr: "10",
    unit: "203",
  },
  {
    addr: "11",
    unit: "204",
  },
  {
    addr: "12",
    unit: "205",
  },
  {
    addr: "13",
    unit: "206",
  },
  {
    addr: "14",
    unit: "207",
  },
  {
    addr: "15",
    unit: "301",
  },
  {
    addr: "16",
    unit: "302",
  },
  {
    addr: "17",
    unit: "303",
  },
  {
    addr: "18",
    unit: "304",
  },
  {
    addr: "19",
    unit: "305",
  },
  {
    addr: "20",
    unit: "306",
  },
  {
    addr: "21",
    unit: "307",
  },
  {
    addr: "22",
    unit: "401",
  },
  {
    addr: "23",
    unit: "402",
  },
  {
    addr: "24",
    unit: "403",
  },
  {
    addr: "25",
    unit: "404",
  },
  {
    addr: "26",
    unit: "405",
  },
  {
    addr: "27",
    unit: "406",
  },
  {
    addr: "28",
    unit: "407",
  },
  {
    addr: "29",
    unit: "501",
  },
  {
    addr: "30",
    unit: "502",
  },
  {
    addr: "31",
    unit: "503",
  },
  {
    addr: "32",
    unit: "504",
  },
  {
    addr: "33",
    unit: "505",
  },
  {
    addr: "34",
    unit: "506",
  },
  {
    addr: "35",
    unit: "507",
  },
  {
    addr: "36",
    unit: "601",
  },
  {
    addr: "37",
    unit: "602",
  },
  {
    addr: "38",
    unit: "603",
  },
  {
    addr: "39",
    unit: "604",
  },
  {
    addr: "40",
    unit: "605",
  },
  {
    addr: "41",
    unit: "606",
  },
  {
    addr: "42",
    unit: "607",
  },
  {
    addr: "43",
    unit: "701",
  },
  {
    addr: "44",
    unit: "702",
  },
  {
    addr: "45",
    unit: "703",
  },
  {
    addr: "46",
    unit: "704",
  },
  {
    addr: "47",
    unit: "705",
  },
  {
    addr: "48",
    unit: "706",
  },
  {
    addr: "49",
    unit: "707",
  },
  {
    addr: "50",
    unit: "801",
  },
  {
    addr: "51",
    unit: "802",
  },
  {
    addr: "52",
    unit: "803",
  },
  {
    addr: "53",
    unit: "804",
  },
  {
    addr: "54",
    unit: "805",
  },
  {
    addr: "55",
    unit: "806",
  },
  {
    addr: "56",
    unit: "807",
  },
  {
    addr: "57",
    unit: "901",
  },
  {
    addr: "58",
    unit: "902",
  },
  {
    addr: "59",
    unit: "903",
  },
  {
    addr: "60",
    unit: "904",
  },
  {
    addr: "61",
    unit: "905",
  },
  {
    addr: "62",
    unit: "906",
  },
  {
    addr: "63",
    unit: "907",
  },
  {
    addr: "64",
    unit: "1001",
  },
  {
    addr: "65",
    unit: "1002",
  },
  {
    addr: "66",
    unit: "1003",
  },
  {
    addr: "67",
    unit: "1004",
  },
  {
    addr: "68",
    unit: "1005",
  },
  {
    addr: "69",
    unit: "1006",
  },
  {
    addr: "70",
    unit: "1007",
  },
  {
    addr: "71",
    unit: "1101",
  },
  {
    addr: "72",
    unit: "1102",
  },
  {
    addr: "73",
    unit: "1103",
  },
  {
    addr: "74",
    unit: "1104",
  },
  {
    addr: "75",
    unit: "1105",
  },
  {
    addr: "76",
    unit: "1106",
  },
  {
    addr: "77",
    unit: "1107",
  },
  {
    addr: "78",
    unit: "1201",
  },
  {
    addr: "79",
    unit: "1202",
  },
  {
    addr: "80",
    unit: "1203",
  },
  {
    addr: "81",
    unit: "1204",
  },
  {
    addr: "82",
    unit: "1205",
  },
  {
    addr: "83",
    unit: "1206",
  },
  {
    addr: "84",
    unit: "1207",
  },
  {
    addr: "85",
    unit: "1301",
  },
  {
    addr: "86",
    unit: "1302",
  },
  {
    addr: "87",
    unit: "1303",
  },
  {
    addr: "88",
    unit: "1304",
  },
  {
    addr: "89",
    unit: "1305",
  },
  {
    addr: "90",
    unit: "1306",
  },
  {
    addr: "91",
    unit: "1307",
  },
  {
    addr: "92",
    unit: "1401",
  },
  {
    addr: "93",
    unit: "1402",
  },
  {
    addr: "94",
    unit: "1403",
  },
  {
    addr: "95",
    unit: "1404",
  },
  {
    addr: "96",
    unit: "1405",
  },
  {
    addr: "97",
    unit: "1406",
  },
  {
    addr: "98",
    unit: "1407",
  },
  {
    addr: "99",
    unit: "1501",
  },
  {
    addr: "100",
    unit: "1502",
  },
  {
    addr: "101",
    unit: "1503",
  },
  {
    addr: "102",
    unit: "1504",
  },
  {
    addr: "103",
    unit: "1505",
  },
  {
    addr: "104",
    unit: "1506",
  },
  {
    addr: "105",
    unit: "1601",
  },
  {
    addr: "106",
    unit: "1602",
  },
  {
    addr: "107",
    unit: "1603",
  },
  {
    addr: "108",
    unit: "1604",
  },
  {
    addr: "109",
    unit: "1605",
  },
  {
    addr: "110",
    unit: "1606",
  },
  {
    addr: "111",
    unit: "1701",
  },
  {
    addr: "112",
    unit: "1702",
  },
  {
    addr: "113",
    unit: "1703",
  },
  {
    addr: "114",
    unit: "1704",
  },
  {
    addr: "115",
    unit: "1705",
  },
  {
    addr: "116",
    unit: "1706",
  },
  {
    addr: "117",
    unit: "1801",
  },
  {
    addr: "118",
    unit: "1802",
  },
  {
    addr: "119",
    unit: "1803",
  },
  {
    addr: "120",
    unit: "1804",
  },
  {
    addr: "121",
    unit: "1805",
  },
  {
    addr: "122",
    unit: "1806",
  },
  {
    addr: "123",
    unit: "1901",
  },
  {
    addr: "124",
    unit: "1902",
  },
  {
    addr: "125",
    unit: "1903",
  },
  {
    addr: "126",
    unit: "1904",
  },
  {
    addr: "127",
    unit: "1905",
  },
  {
    addr: "128",
    unit: "1906",
  },
  {
    addr: "129",
    unit: "2001",
  },
  {
    addr: "130",
    unit: "2002",
  },
  {
    addr: "131",
    unit: "2003",
  },
  {
    addr: "132",
    unit: "2004",
  },
  {
    addr: "133",
    unit: "2005",
  },
  {
    addr: "134",
    unit: "2006",
  },
  {
    addr: "135",
    unit: "2101",
  },
  {
    addr: "136",
    unit: "2102",
  },
  {
    addr: "137",
    unit: "2103",
  },
  {
    addr: "138",
    unit: "2104",
  },
  {
    addr: "139",
    unit: "2105",
  },
  {
    addr: "140",
    unit: "2106",
  },
  {
    addr: "141",
    unit: "2201",
  },
  {
    addr: "142",
    unit: "2202",
  },
  {
    addr: "143",
    unit: "2203",
  },
  {
    addr: "144",
    unit: "2204",
  },
  {
    addr: "145",
    unit: "2205",
  },
  {
    addr: "146",
    unit: "2206",
  },
  {
    addr: "147",
    unit: "2301",
  },
  {
    addr: "148",
    unit: "2302",
  },
  {
    addr: "149",
    unit: "2303",
  },
]

export default allUnits
